import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var QrIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M7.286 15C8.232 15 9 15.768 9 16.714v4.572C9 22.232 8.232 23 7.286 23H2.714A1.714 1.714 0 011 21.286v-4.572C1 15.768 1.768 15 2.714 15zM12 18c.557 0 .942.345.994.875L13 19v3c0 .6-.4 1-1 1h-1c-.557 0-.942-.345-.994-.875L10 22v-3c0-.6.4-1 1-1h1zm10-1c.6 0 1 .4 1 1l-.001 1.982L23 20c0 .557-.345.942-.875.994L22 21h-1v1c0 .6-.4 1-1 1h-5c-.6 0-1-.4-1-1s.4-1 1-1h4v-1c0-.557.345-.942.875-.994L20 19h.999L21 18c0-.557.345-.942.875-.994zM6.6 17H3.4a.4.4 0 00-.4.4v3.2c0 .22.18.4.4.4h3.2a.4.4 0 00.4-.4v-3.2a.4.4 0 00-.4-.4zM17 15c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1s-1-.4-1-1v-1h-1c-.6 0-1-.4-1-1s.4-1 1-1zm-6 0c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm11-5c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1s-1-.4-1-1v-1h-1c-.6 0-1-.4-1-1s.4-1 1-1h1v-1c0-.6.4-1 1-1zM7 10c.6 0 1 .4 1 1v1h1c.557 0 .942.345.994.875L10 13c0 .6-.4 1-1 1H7c-.257 0-.478-.073-.645-.205l-.08-.07C6.1 13.55 6 13.3 6 13v-1H5c-.557 0-.942-.345-.994-.875L4 11c0-.6.4-1 1-1zm10 0l.125.006c.53.052.875.437.875.994 0 .6-.4 1-1 1h-1v1l-.006.125c-.052.53-.437.875-.994.875h-2c-.6 0-1-.4-1-1v-2l.006-.125c.052-.53.437-.875.994-.875h4zM2 12c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zM21.286 1C22.232 1 23 1.768 23 2.714v4.572C23 8.232 22.232 9 21.286 9h-4.572A1.714 1.714 0 0115 7.286V2.714C15 1.768 15.768 1 16.714 1zm-14 0C8.232 1 9 1.768 9 2.714v4.572C9 8.232 8.232 9 7.286 9H2.714A1.714 1.714 0 011 7.286V2.714C1 1.768 1.768 1 2.714 1zM11 2c.6 0 1 .4 1 1v2h1c.557 0 .942.345.994.875L14 6c0 .6-.4 1-1 1h-1v1c0 .557-.345.942-.875.994L11 9c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1zm9.6 1h-3.2a.4.4 0 00-.4.4v3.2c0 .22.18.4.4.4h3.2a.4.4 0 00.4-.4V3.4a.4.4 0 00-.4-.4zm-14 0H3.4a.4.4 0 00-.4.4v3.2c0 .22.18.4.4.4h3.2a.4.4 0 00.4-.4V3.4a.4.4 0 00-.4-.4z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
QrIcon.isCarinaIcon = true;
export default QrIcon;
